"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Search = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const config_1 = require("@completeanatomy/config");
const http_1 = require("@completeanatomy/http");
const SearchApi_1 = require("../components/api/SearchApi");
require("reflect-metadata");
const typedi_1 = __importStar(require("typedi"));
let Search = class Search {
    /**
     * Creates instance of Search service.
     *
     * @param http - the HTTP module to make HTTP requests
     */
    constructor() {
        this.searchAPI = new SearchApi_1.SearchAPI(typedi_1.default.get(http_1.HTTP), typedi_1.default.get(config_1.Config));
    }
    getList(search, modelId, version, lang = 'en') {
        return __awaiter(this, void 0, void 0, function* () {
            const searchResult = yield this.searchAPI.list(search, modelId, version, lang);
            const structures = [];
            const landMarks = [];
            const motions = [];
            const availableTabs = new Set();
            searchResult.forEach(item => {
                if (item['content_type'].length === 0) {
                    return;
                }
                if (item['content_type'].length === 1 &&
                    item['content_type'][0] === bridge_schema_1.SearchContentType.Medias) {
                    return;
                }
                item.content_type.forEach(type => {
                    if (type === bridge_schema_1.SearchContentType.Medias) {
                        return;
                    }
                    if (type === bridge_schema_1.SearchContentType.Shapes ||
                        type === bridge_schema_1.SearchContentType.Spots) {
                        landMarks.push(Object.assign(Object.assign({}, item), { content_type: [type] }));
                        availableTabs.add(bridge_schema_1.SearchContentType.Spots);
                        return;
                    }
                    structures.push(Object.assign(Object.assign({}, item), { content_type: [type] }));
                    availableTabs.add(bridge_schema_1.SearchContentType.Structures);
                });
            });
            // split by structure and motion
            const result = {
                structures: structures,
                motions: motions,
                landMarks: landMarks,
                length: structures.length + motions.length + landMarks.length,
                availableTabs: Array.from(availableTabs),
            };
            return result;
        });
    }
};
exports.Search = Search;
exports.Search = Search = __decorate([
    (0, typedi_1.Service)(),
    __metadata("design:paramtypes", [])
], Search);
